import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../aGlobalDesign/Area/Area";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import ButtonSKA from "../../aGlobalDesign/Buttons/ButtonSKA";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../aGlobalDesign/Modal/Modal";
import AppBar from "../../aGlobalDesign/Modal/AppBar";
import Status from "../../aGlobalDesign/Status/Status";

class DisplaysList extends React.Component {

    constructor() {
        super();
        this.state = {
            displayParameters: [],
            searchField: "",
            forcePaginationUpdate: 0,
            restrictedZones: null,
            temporaryElement: null,
            selectedDisplay: null,
            sem: null,
            logsList: null,
            adminMenu: null,
            openModalStatus: false,
            selectedStatusElement: null,
            selectModeStatus: { id: "available", name: strings.Available }
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.PortalsClient);
        this.props.ChangeCurrentMenuName("PortalsClient");

        if (!this.props.administration.secondaryzones) {
            this.props.GetSecondaryZonesList();
        }

        let displayParameters = [];
        if (this.props.currentuser.currentorganization.displayParameters !== null) {
            displayParameters = JSON.parse(this.props.currentuser.currentorganization.displayParameters);
            displayParameters.forEach(param => {
                param.value = param.defaultValue;
            });
        }
        this.props.GetRestrictedZones((data) => {
            this.setState({
                displayParameters: displayParameters,
                restrictedZones: data
            });
        });
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedDisplay: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }

    //#region functions
    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteItem,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteDisplay(id, onSuccess);
            }
        });
    }

    OnLoad(display) {
        let d = display;
        const zones = this.state.restrictedZones;
        const zoneId = zones.results.length > 0 && this.props.currentuser.accessrights.hasPermission(90, "create") === 20 ? zones.results[0].id : null;
        if (d === null) {
            d = {
                id: 0,
                name: "",
                description: "",
                startUI: "",
                uniqueIdentifier: "",
                zone: null,
                zoneId: zoneId,
                displayType: this.props.dictionaries.displayTypes.find(dt => dt.id === 20),
                displayTypeId: 20,
                location: "",
                timestamp: null,
                organizationId: this.props.currentuser.currentorganization.id,
                displayParameters: this.state.displayParameters
            };
            const temp = this.CreateTemp(d);
            this.setState({
                selectedDisplay: d,
                temporaryElement: temp
            });
        }
        else {
            this.props.GetDisplay(d.id, (data) => {
                const temp = this.CreateTemp(data);
                this.setState({
                    selectedDisplay: d,
                    temporaryElement: temp
                });
            });
        }
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            description: element.description,
            uniqueIdentifier: element.uniqueIdentifier,
            location: element.location,
            zoneId: element.zoneId,
            displayParameters: element.displayParameters
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        element.uniqueIdentifier = temp.uniqueIdentifier;
        element.location = temp.location;
        element.zoneId = temp.zoneId;
        element.displayParameters = temp.displayParameters;
        element.timestamp = temp.timestamp;
        return element;
    }
    saveSelectedDisplay() {
        const display = this.state.selectedDisplay;
        this.SaveTemp(this.state.temporaryElement, display);
        if ( display.name === "") {
            this.props.OpenDialog({
                description: strings.alertName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const d = {
            id: display.id,
            name: display.name,
            description: display.description,
            uniqueIdentifier: display.uniqueIdentifier,
            displayTypeId: display.displayTypeId,
            organizationId: this.props.currentuser.currentorganization.id,
            zoneId: display.zoneId,
            location: display.location,
            timestamp: display.timestamp,
            displayParameters: display.displayParameters || this.state.displayParameters
        };

        if (display.id === 0) {
            this.props.CreateDisplay(d,
                (id) => {
                    this.forcePaginationUpdate();
                });
        }
        else {
            this.props.EditDisplay(
                d,
                (updatedDisplayTimestamp) => {
                    toast.success(strings.successfullSaveDisplay);
                    this.forcePaginationUpdate();
                }
            );
        }
    }

    trim(text, length) {
        if (text.length > length) {
            text = text.substring(0, length) + "...";
        }
        return text;
    }

    getStatus(stat) {
        const numberStat = Number(stat);
        switch (numberStat) {
            case 60 : return strings.CallInProgress;
            case 45 : return strings.WaitingList;
            case 10 : return strings.OffLine;
            case 20 : return strings.OffLine;
            case 30 : return strings.SleepMode;
            case 40 : return strings.Available;
            case 50 : return strings.IncomingCall;
            case 70 : return strings.BreakMode;
            default : return strings.NoStatus;
        }
    }
    //#endregion

    modeSleep(element, mode) {
        this.props.handleSleepMode(Number(element.id), mode, () => {
            this.setState({
                openModalStatus: false,
                selectedStatusElement: null
            });
        });
    }

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={
                    (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) =>
                        this.props.GetDisplaysList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary)
                }
                onSavePagination={this.props.SaveDisplaysPagination}
                myElements={this.props.monitoring.displays}
                updateRowOnChange={this.props.monitoring.callapps}

                sortOptions={[
                    { sortName: "status", sortData: "null" },
                    { sortName: "name", sortData: "asc" },
                    { sortName: "description", sortData: "null" },
                    { sortName: "zone", sortData: "null" },
                    { sortName: "applicationVersion", sortData: "null" },
                    { sortName: "lastactivity", sortData: "null" }
                ]}

                tableElement={(element, onReloadList) => {
                    const callApp = element && this.props.monitoring.callapps ? this.props.monitoring.callapps.find(ca => ca.uniqueIdentifier === element.uniqueIdentifier) : null;
                    return [
                        {
                            colTitle: strings.SortStatus,
                            fixedWidth: "200px",
                            lockWidth: true,
                            sortIndex: 0,
                            cellRenderer: ({ data, column }) => {
                                const value = data[column.field];
                                if (value) {
                                    const isDisabledButtonStatus = !value
                                            || value.portalStatusId === 50
                                            || value.portalStatusId === 60
                                            || value.portalStatusId === 10 && value.modeSleep !== 2
                                            || value.portalStatusId === 20 && value.modeSleep !== 2
                                            || !accessrights
                                            || !accessrights.hasPermission(90, "modify") > 10;
                                    return <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px"
                                        }} >
                                        <div>
                                            <Status
                                                statusId={value.modeSleep === 2 ? 30 : value.modeSleep === 1 ? 70 : value.portalStatusId}
                                                disabledTooltip={true}
                                            />
                                        </div>
                                        <button disabled={isDisabledButtonStatus}
                                            onClick={() =>
                                                this.setState({
                                                    openModalStatus: true,
                                                    selectedStatusElement: value,
                                                    selectModeStatus: value.modeSleep === 2 ? { id: "sleepMode", name: strings.SleepMode } : { id: "available", name: strings.Available }
                                                })
                                            }
                                            style={{
                                                cursor: isDisabledButtonStatus ? "default" : "pointer",
                                                border: "none",
                                                background: "none",
                                                textDecoration: "underline",
                                                textDecorationColor: isDisabledButtonStatus ? "var(--grey-light)" : "var(--carbone)"
                                            }}>
                                            {this.getStatus(value.modeSleep === 2 ? 30 : value.modeSleep === 1 ? 70 : value.portalStatusId)}
                                        </button>
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                portalStatusId: element.portalStatusId,
                                modeSleep: element.modeSleep,
                                id: element.id
                            } : null
                        },
                        /*{
                                colTitle: "File d'attente",
                                fixedWidth: "110px",
                                colContent: element ? this.getStatus(callApp ? callApp.status : element.portalStatusId) : null
                            },*/
                        {
                            colTitle: strings.SortName,
                            fixedWidth: "200px",
                            sortIndex: 1,
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            fixedWidth: "200px",
                            sortIndex: 2,
                            colContent: element ? element.description : null
                        },
                        {
                            colTitle: strings.Zone,
                            fixedWidth: "200px",
                            sortIndex: 3,
                            colContent: element && element.zone ? element.zone.name : null
                        },
                        // {
                        //     colTitle: strings.SortDisplayStateUpdate,
                        //     flex: "3",
                        //     sortIndex: 6,
                        //     colContent: element && element.displayStateUpdateDate ? element.displayStateUpdateDate : null
                        // },
                        {
                            colTitle: strings.Position,
                            fixedWidth: "100px",
                            lockWidth: true,
                            justify: "center",
                            colContent: callApp ? callApp.position : null
                        },
                        {
                            colTitle: strings.SortPlayerVersion,
                            fixedWidth: "200px",
                            lockWidth: true,
                            sortIndex: 4,
                            colContent: element && element.applicationVersion !== null && element.webAppVersion !== null ?
                                element.applicationVersion + " (" + element.webAppVersion + ")"
                                :
                                element && element.applicationVersion !== null ?
                                    element.applicationVersion
                                    :
                                    element && element.webAppVersion !== null ?
                                        " (" + element.webAppVersion + ")"
                                        :
                                        null
                        },
                        {
                            colTitle: strings.SortActions,
                            colType: "actions",
                            actions: isSystemAdministrator ? [1, 2, 3, 4] : [1, 2, 3],
                            colContent: [
                                isSystemAdministrator ?
                                    <ButtonSkaRound
                                        key={"settings"}
                                        type="primary"
                                        onClick={() => this.setState({ adminMenu: {
                                            portalName: element.name,
                                            portalUniqueIdentifier: element.uniqueIdentifier,
                                            commands: ["RestartWebApp", "RestartApp", "RestartDevice", "CheckUpdateForAll", "CheckUpdateForOrga", "CheckUpdateForDevice", "GetTechnicalLogs"]
                                                .map((com) => {return { command: com };})
                                        } })}
                                        nameIcon="settings"
                                    /> : null,
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(90, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoad(element);
                                    }}
                                    nameIcon="eye"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    isDisabled={!accessrights || accessrights.hasPermission(90, "modify") <= 10}
                                    type="primary"
                                    onClick={() => this.OnLoad(element)}
                                    nameIcon="edit"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(90, "delete") <= 10}
                                    onClick={() => this.OnDelete(element.id, () => this.forcePaginationUpdate())}
                                    nameIcon="trash"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedDisplay !== null}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({ preview: false, selectedDisplay: null });
                    }
                }}
                title={this.state.preview ? strings.infoCapsule : this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? strings.editCapsule : strings.CreateNewDisplay}
                icon={this.state.preview ? "information" : this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? "edit" : "add"}
                validationIcon={this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? "save" : null}
                validationTitle={this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? strings.register : null}
                fields={
                    this.state.temporaryElement ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            disabled: this.state.preview,
                            placeholder: strings.newCapsule,
                            value: this.state.temporaryElement.name,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.name = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.Description,
                            disabled: this.state.preview,
                            placeholder: strings.hisDescritif,
                            value: this.state.temporaryElement.description,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.description = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.location,
                            disabled: this.state.preview,
                            placeholder: "Ex. : Paris",
                            value: this.state.temporaryElement.location,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.location = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.ID,
                            placeholder: strings.ID,
                            disabled: this.state.preview || this.state.temporaryElement.id !== 0,
                            value: this.state.temporaryElement.uniqueIdentifier,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.uniqueIdentifier = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.Zone,
                            openTop: true,
                            disabled: this.state.preview,
                            preventEmpty: true,
                            elementsList: this.props.administration.secondaryzones,
                            selectedElementId: this.state.temporaryElement.zoneId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (element && accessrights.hasPermission(90, "modify") === 20) {
                                    const zindex = this.state.restrictedZones.results.findIndex(z => z.id === element.id);
                                    if (zindex < 0) {return;}
                                }

                                temp.zoneId = element ? element.id : null;
                                temp.zone = element;
                                this.setState({ temporaryElement: temp });
                            }
                        }
                    ].concat(!isSystemAdministrator ? [] : this.state.temporaryElement.displayParameters.map((displayParam, dpindex) => {
                        return (
                            displayParam.key === "SizeCapsule" ?
                                {
                                    type: "selectElement",
                                    title: strings.SizeCapsule,
                                    openTop: true,
                                    preventEmpty: true,
                                    placeholder: strings.None,
                                    elementsList: { results: [
                                        { id: "0", name: `${strings.None}` },
                                        { id: "22", name: `22 ${strings.inch}` },
                                        { id: "32", name: `32 ${strings.inch}` },
                                        { id: "55", name: `55 ${strings.inch}` }
                                    ] },
                                    selectedElementId: displayParam.value,
                                    onSelectElement: (element) => {
                                        const dp = this.state.temporaryElement;
                                        dp.displayParameters[dpindex].value = element.id;
                                        this.setState({ temporaryElement: dp });
                                    }
                                }
                                :
                                {
                                    type: "textarea",
                                    title: displayParam.key,
                                    value: displayParam.value,
                                    disabled: this.state.preview,
                                    onChange: (e) => {
                                        const dp = this.state.temporaryElement;
                                        dp.displayParameters[dpindex].value = e.target.value;
                                        this.setState({ temporaryElement: dp });
                                    }
                                });
                    })) : null
                }
                onValidate={this.state.selectedDisplay && !this.state.preview ? () => this.saveSelectedDisplay() : null }
            >
            </Modal>
            <Modal open={this.state.adminMenu !== null}
                onClose={() => this.setState({ adminMenu: null })}
                title={(this.state.adminMenu ? this.state.adminMenu.portalName : "") + " - Admin"}
                icon={"settings"}
            >
                {this.state.adminMenu ?
                    <>
                        {
                            this.state.adminMenu.commands.map((el) => {
                                return <ButtonSKA
                                    key={el.command}
                                    disabled={!this.props.communication || !this.props.communication.webRTConnection }
                                    type="primary"
                                    text={el.command}
                                    onClick={() => {
                                        console.log("invoke ==> SendAdminCommand", this.state.adminMenu.portalUniqueIdentifier + " ; " + el.command);
                                        this.props.communication.webRTConnection.invoke("SendAdminCommand", this.state.adminMenu.portalUniqueIdentifier, el.command);
                                        toast.success(`${el.command} OK`);
                                    }}
                                />;
                            })
                        }
                        <ButtonSKA
                            disabled={!this.props.communication || !this.props.communication.webRTConnection }
                            type="primary"
                            text={strings.ShowAllLogs}
                            onClick={() => {
                                this.props.GetDisplayLogs(this.state.adminMenu.portalUniqueIdentifier, (logs) => {
                                    this.setState({ logsList: logs });
                                });
                            }}
                        />
                    </>
                    : null}
            </Modal>
            <Modal open={this.state.logsList !== null}
                onClose={() => this.setState({ logsList: null })}
                title={(this.state.adminMenu ? this.state.adminMenu.portalName : "") + " - Logs"}
                icon={"settings"}
            >
                {this.state.adminMenu && this.state.logsList ? this.state.logsList.length <= 0 ?
                    strings.NoLogsInStorage
                    :
                    <AppBar
                        slides={[
                            {
                                title: "Logs UWP",
                                content: <>
                                    {
                                        this.state.logsList.slice().reverse().map((log, index) => {
                                            return log.includes("/UWP") ?
                                                <a key={index} href={log}>{log}</a>
                                                :
                                                null;
                                        })
                                    }
                                </>
                            },
                            {
                                title: "Logs WebApp",
                                content: <>
                                    {
                                        this.state.logsList.slice().reverse().map((log, index) => {
                                            return log.includes("/webapp") ?
                                                <a key={index} href={log}>{log}</a>
                                                :
                                                null;
                                        })
                                    }
                                </>
                            }
                        ]}/> : null}
            </Modal>
            <Modal open={this.state.openModalStatus}
                onClose={() => this.setState({
                    openModalStatus: false
                })}
                title={strings.StatusCapsule}
                icon={"tool"}
                validationTitle={strings.confirmButton}
                fields={ [
                    {
                        type: "selectElement",
                        preventEmpty: true,
                        elementsList: { results: [
                            { id: "available", name: strings.Available },
                            { id: "sleepMode", name: strings.SleepMode }
                        ] },
                        value: this.state.selectModeStatus,
                        selectedElementId: this.state.selectModeStatus.id,
                        onSelectElement: (element) => {
                            this.setState({ selectModeStatus: element });
                        }
                    },
                    this.state.selectModeStatus ?
                        {
                            type: "custom",
                            child: <p style={{ fontSize: "14px", fontWeight: 400, margin: 0 }}>
                                {
                                    this.state.selectModeStatus.id === "sleepMode" ?
                                        strings.MessageStatusSleepModeCapsule
                                        :
                                        strings.MessageStatusAvailableCapsule
                                }
                            </p>
                        }
                        :
                        null
                ]}
                onValidate={() => {
                    const el = this.state.selectedStatusElement;
                    const selectedStatus = this.state.selectModeStatus.id;
                    if (!el) {return;}

                    if (selectedStatus === "available") {this.modeSleep(el, 0);}
                    else if (selectedStatus === "sleepMode") {this.modeSleep(el, 2);}
                }}
            >
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(DisplaysList);
